// De Almeda Seligmann Capital AG — content

export const COMPANY = {
  name: 'De Almeda Seligmann',
  fullName: 'De Almeda Seligmann Capital AG',
  short: 'DASC',
  tagline: 'Enduring Capital · Considered Stewardship',
  headquarters: 'Zug, Switzerland',
  founded: 2021,
  foundedBy: 'Swiss Investors',
  contactEmail: 'main@dealmedaseligmann.ch',
  contactPhone: '+41 41 711 79 32',
  contactPhoneRaw: '+41417117932',
  addressLines: [
    'Gotthardstrasse 20',
    '6300 Zug',
    'Switzerland',
  ],
  logoWhite: '/brand/logo-full-red.png',
  markWhite: '/brand/mark-red.png',
  logoFullRed: '/brand/logo-full-red.png',
  markRed: '/brand/mark-red.png',
};

export const STATS = [
  { value: 'V', label: 'Portfolio Companies' },
  { value: '3', label: 'Continents of Operation' },
  { value: 'MMXXI', label: 'Founded in Zug' },
  { value: 'AG', label: 'Swiss Aktiengesellschaft' },
];

export const PORTFOLIO = [
  {
    slug: 'hupla-gida',
    name: 'Hupla Gıda Üretim A.Ş.',
    shortName: 'Hupla Gıda',
    sector: 'Food & Beverage Production',
    country: 'Türkiye',
    location: 'Istanbul',
    logo: '/companies/hupla.png',
    contact: {
      address: 'Büyükdere Cd. 175/6, Ferko Signature, Esentepe, Şişli 34394 İstanbul, Türkiye',
      email: 'hello@hupla.world',
      phone: '+90 850 302 40 60',
      mobile: '+90 532 284 42 83',
      website: 'https://www.hupla.world',
    },
    description:
      'A Turkish food and beverage production platform focused on premium ingredients and manufacturing standards suited to regional and international channels. The company\'s portfolio spans a full spectrum of proprietary brands — each with an established presence in the Turkish market and a growing footprint across international channels.',
    image:
      'https://images.unsplash.com/photo-1602052577122-f73b9710adba?crop=entropy&cs=srgb&fm=jpg&q=85',
    imageAlt:
      'https://images.unsplash.com/photo-1546554137-f86b9593a222?crop=entropy&cs=srgb&fm=jpg&q=85',
  },
  {
    slug: 'ta-cle-invest',
    name: 'TA Clé Invest',
    fullName: 'TA Clé Invest Gayrimenkul Yatırım ve Finans A.Ş.',
    shortName: 'TA Clé Invest',
    sector: 'Real Estate Investment & Finance',
    country: 'Türkiye',
    location: 'Istanbul',
    logo: '/companies/ta-cle-invest.png',
    contact: {
      address: 'Büyükdere Cd. 175/6, Ferko Signature, Esentepe, Şişli 34394 İstanbul, Türkiye',
      email: 'hello@tacleinvest.com',
      phone: '+90 850 302 40 60',
      mobile: '+90 532 284 42 83',
      website: 'https://www.tacleinvest.com',
    },
    description:
      "A real-estate investment and finance platform holding a substantial portfolio of commercial and industrial land alongside residential properties across strategic Turkish markets — assembled for compounding rental yield and long-term land value. TA Clé Invest is also the developer of a private villa project on Türkiye's South Aegean coast: a considered seaside address defined by high-end detailing.",
    image:
      'https://images.unsplash.com/photo-1619218070141-bcfeb8b93074?crop=entropy&cs=srgb&fm=jpg&q=85',
  },
  {
    slug: 'chasing-rabbit',
    name: 'Chasing Rabbit',
    fullName: 'Chasing Rabbit Eğlence ve Dinlenme Hizmetleri A.Ş.',
    shortName: 'Chasing Rabbit',
    sector: 'Hospitality & Leisure',
    country: 'Türkiye',
    location: 'Istanbul',
    logo: '/companies/chasing-rabbit.png',
    contact: {
      address: 'Büyükdere Cd. 175/6, Ferko Signature, Esentepe, Şişli 34394 İstanbul, Türkiye',
      email: 'hello@chasingrabbit.org',
      phone: '+90 850 302 40 60',
      mobile: '+90 532 284 42 83',
    },
    description:
      'An experience-led hospitality and leisure operator building distinctive destinations for the modern, discerning traveller — from private clubs to considered venues.',
    image:
      'https://images.unsplash.com/photo-1511454493857-0a29f2c023c7?crop=entropy&cs=srgb&fm=jpg&q=85',
  },
  {
    slug: 'van-lynden-bv',
    name: 'Van Lynden B.V.',
    shortName: 'Van Lynden',
    sector: 'Food Ingredients',
    country: 'The Netherlands',
    location: 'Rotterdam',
    logo: '/companies/van-lynden.png',
    tagline: 'better ingredients',
    contact: {
      address: 'Weena 690, 3012 CN Rotterdam, Netherlands',
      email: 'lynden@van-lynden.com',
    },
    description:
      'A Dutch specialty food-ingredients house sourcing and distributing superior raw materials — the "better ingredients" philosophy in service of European food and beverage manufacturers.',
    image:
      'https://images.unsplash.com/photo-1611974789855-9c2a0a7236a3?crop=entropy&cs=srgb&fm=jpg&q=85',
  },
  {
    slug: 'amazonia-sources',
    name: 'Amazonia Sources S.A.C.',
    shortName: 'Amazonia Sources',
    sector: 'Natural Resources & Botanicals',
    country: 'Peru',
    location: '',
    logo: null,
    contact: {
      email: 'hello@amazoniasources.com',
    },
    description:
      'A Peruvian sourcing platform for Amazonian botanicals, superfoods, and natural ingredients — connecting curated rainforest supply chains with premium international buyers.',
    image:
      'https://images.unsplash.com/photo-1596040033229-a9821ebd058d?crop=entropy&cs=srgb&fm=jpg&q=85',
  },
];

export const LEADERSHIP = [
  {
    name: 'The Board of Directors',
    role: 'Governance & Oversight',
    bio: 'Composed of senior stewards from finance, law, and industry, the Board sets the long-horizon direction of the Capital AG and its subsidiaries.',
    image:
      'https://images.pexels.com/photos/37148345/pexels-photo-37148345.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
  },
  {
    name: 'Executive Committee',
    role: 'Capital Allocation',
    bio: 'The Executive Committee steers portfolio strategy, underwrites new commitments, and ensures every subsidiary is capitalised for its next decade of work.',
    image:
      'https://images.unsplash.com/photo-1758600587730-a11917c13b85?crop=entropy&cs=srgb&fm=jpg&q=85',
  },
  {
    name: 'Portfolio Operations',
    role: 'Enterprise Value Creation',
    bio: 'A small team of operator-advisors working shoulder-to-shoulder with subsidiary CEOs on strategy, talent, controls, and enduring performance.',
    image:
      'https://images.pexels.com/photos/28446973/pexels-photo-28446973.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
  },
  {
    name: 'Advisory Council',
    role: 'External Counsel',
    bio: 'International advisors from law, geopolitics, and industry, convened to sharpen the firm\'s judgement on complex and cross-border matters.',
    image:
      'https://images.unsplash.com/photo-1745060594679-61578eb592f7?crop=entropy&cs=srgb&fm=jpg&q=85',
  },
];

export const INSIGHTS = [
  {
    slug: 'the-swiss-idea-of-capital',
    category: 'Perspective',
    date: 'February 2026',
    headline: 'The Swiss Idea of Capital — Patience as a First Principle',
    excerpt:
      'On why our decisions are made in Zug and measured in decades — not in the reflex of quarterly weather.',
    image:
      'https://images.unsplash.com/photo-1546846195-825303d86f02?crop=entropy&cs=srgb&fm=jpg&q=85',
  },
  {
    slug: 'the-anatolian-thesis',
    category: 'Portfolio Note',
    date: 'January 2026',
    headline: 'The Anatolian Thesis — Building Long-Life Businesses in Türkiye',
    excerpt:
      'How Hupla, TA Clé Invest and Chasing Rabbit express a single, structured view of durable value creation in the Turkish economy.',
    image:
      'https://images.unsplash.com/photo-1703639948834-342fc34900f8?crop=entropy&cs=srgb&fm=jpg&q=85',
  },
  {
    slug: 'the-quiet-holding-company',
    category: 'Letter',
    date: 'December 2025',
    headline: 'The Quiet Holding Company — A Structural Advantage',
    excerpt:
      'Why our permanent capital, small perimeter, and disciplined governance are, together, a competitive moat that compounds silently.',
    image:
      'https://images.unsplash.com/photo-1472803828399-39d4ac53c6e5?crop=entropy&cs=srgb&fm=jpg&q=85',
  },
];

export const PRINCIPLES = [
  {
    number: '01',
    title: 'Permanence over pace',
    body: 'We hold no fund horizon. Our capital is patient by structure, so our judgement can be patient by choice.',
  },
  {
    number: '02',
    title: 'Concentration, not proliferation',
    body: 'A small number of businesses, each receiving the full weight of our attention, our network, and our conviction.',
  },
  {
    number: '03',
    title: 'Operators, not observers',
    body: 'We invest with humility and stay close to the work. The best boards act like partners; the best partners act like operators.',
  },
  {
    number: '04',
    title: 'The Swiss standard',
    body: 'Discretion, governance, and precision. The way we conduct ourselves is, in the end, the most durable asset we own.',
  },
];

export const NAV_LINKS = [
  { to: '/', label: 'Home' },
  { to: '/about', label: 'About' },
  { to: '/portfolio', label: 'Portfolio' },
  { to: '/leadership', label: 'Leadership' },
  { to: '/insights', label: 'Insights' },
  { to: '/contact', label: 'Contact' },
];
